/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import { Button, theme } from "@nordcloud/gnui";
import { AccountV2Query } from "~/generated/graphql";
import { BreadcrumbsBox } from "~/components";
import { ROUTES } from "~/routing/routes";
import { showDownloadDescriptorButton } from "~/views/accounts/AccountDetails/utils";
import DownloadDescriptorButton from "~/views/accounts/DownloadDescriptorButton";
import {
  getDownloadButtonProps,
  isVMWare,
} from "../../accounts/AccountDetails/utils";

type Props = {
  accountName: string;
  tags: { color: string; text: string }[];
  account: AccountV2Query["accountV2"];
  openCredentialsUpdateSteps: () => void;
  showUpdateCredentials: boolean;
};

export function Header({
  tags,
  account,
  accountName,
  openCredentialsUpdateSteps,
  showUpdateCredentials,
}: Props) {
  const breadcrumbLabels = [
    { uri: ROUTES.index, label: "Home" },
    { uri: ROUTES.cloudAccounts.index, label: "Cloud Accounts" },
    { uri: ROUTES.cloudAccounts.details, label: accountName },
  ];

  return (
    <BreadcrumbsBox
      title={accountName}
      tags={tags}
      customBreadcrumbs={breadcrumbLabels}
    >
      <When condition={isVMWare(account)}>
        <Button
          icon="externalLink"
          css={{ marginRight: theme.spacing.spacing01 }}
          linkTo="https://docs.mca.nordcloudapp.com/docs/visibility/cloud-accounts/vmware/add-vmware"
        >
          Instructions
        </Button>
      </When>
      <When condition={showDownloadDescriptorButton(account)}>
        <DownloadDescriptorButton {...getDownloadButtonProps(account)} />
      </When>
      <When condition={showUpdateCredentials}>
        <Button
          ml={theme.spacing.spacing02}
          icon="edit"
          onClick={openCredentialsUpdateSteps}
        >
          Update Credentials
        </Button>
      </When>
    </BreadcrumbsBox>
  );
}
